"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputeCacheEntry = void 0;
/**
 * An entry stored in a {@link ComputeCache}.
 */
var ComputeCacheEntry = /** @class */ (function () {
    function ComputeCacheEntry(_value, _getTimestamp) {
        this._value = _value;
        this._getTimestamp = _getTimestamp;
    }
    /**
     * Returns the value and updates its last access timestamp.
     */
    ComputeCacheEntry.prototype.access = function () {
        this._lastAccessTimestamp = this._getTimestamp();
        return this._value;
    };
    /**
     * Indicates whether the cache entry is stale.
     *
     * @param msLifetime The time after which the entry should turn stale if it hasn't been accessed.
     */
    ComputeCacheEntry.prototype.isStale = function (msLifetime) {
        return this._lastAccessTimestamp < (this._getTimestamp() - msLifetime);
    };
    return ComputeCacheEntry;
}());
exports.ComputeCacheEntry = ComputeCacheEntry;
//# sourceMappingURL=ComputeCacheEntry.js.map